import { useIsLoggedIn } from '@order/AuthMachine';
import { useCreateLoyaltyProfileQuery } from '@order/graphql';
import { useFeatureFlag } from '@order/LaunchDarkly';

/**
 * The loyalty profile should be created for sweetpass beta users.
 */
export function useCreateLoyaltyProfile() {
  const isLoggedIn = useIsLoggedIn();

  // ─── Sweetpass Enabled ───────────────────────────────────────────────

  const isSweetpassEnabled = useFeatureFlag('OPS-sweetpass-enabled', {
    listenForChanges: true,
  });

  // ─── Sweetpass Beta Enabled ──────────────────────────────────────────

  const isSweetpassBetaEnabled = useFeatureFlag('OPS-sweetpass-beta-enabled', {
    listenForChanges: true,
  });

  // ─── Existing Loyalty Profile ────────────────────────────────────────

  const [existingLoyaltyProfileResponse] = useCreateLoyaltyProfileQuery({
    requestPolicy: 'cache-only',
    pause: !isLoggedIn,
  });
  const hasExistingLoyaltyProfile = Boolean(
    existingLoyaltyProfileResponse.data?.loyaltyProfile,
  );

  // ─── Create Loyalty Profile ──────────────────────────────────────────

  const shouldConsiderBeta = !isSweetpassEnabled && isSweetpassBetaEnabled;
  const shouldPauseQueryLoyaltyProfile =
    !isLoggedIn || hasExistingLoyaltyProfile || !shouldConsiderBeta;

  useCreateLoyaltyProfileQuery({
    pause: shouldPauseQueryLoyaltyProfile,
    requestPolicy: 'cache-and-network',
  });
}
